import { render, staticRenderFns } from "./OrganizationLayout.vue?vue&type=template&id=2a7b505d&scoped=true&"
import script from "./OrganizationLayout.vue?vue&type=script&lang=js&"
export * from "./OrganizationLayout.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationLayout.vue?vue&type=style&index=0&id=2a7b505d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7b505d",
  null
  
)

export default component.exports